import keyBy from 'lodash.keyby';
import get from 'lodash.get';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import formatDropdownOptions from 'utils/format-dropdown-options';
import { OutputParametricSelector } from 'reselect';

import { AppState } from 'services/types';
// @ts-ignore
import { UnitTypesState, UnitTypesProps, UnitTypeId, UnitType } from './types';

const selectUnitTypes = (state: AppState): UnitTypesState => state.unitTypes;
const selectUnitTypeId = (state: AppState, props: UnitTypesProps): UnitTypeId =>
    props.unitTypeId;

const selectUnitTypeOptions = createDeepEqualSelector(
    selectUnitTypes,
    unitTypes =>
        formatDropdownOptions(unitTypes, {
            keyField: 'id',
            textField: 'name'
        })
);

const selectUnitTypesKeyedById = createDeepEqualSelector(
    selectUnitTypes,
    unitTypes => keyBy(unitTypes, 'id')
);

const selectUnitType = createDeepEqualSelector(
    selectUnitTypesKeyedById,
    selectUnitTypeId,
    (unitTypes, unitTypeId): UnitType => get(unitTypes, unitTypeId)
);

const makeSelectUnitTypeFieldValue = <K extends keyof UnitType>(
    fieldName: K
): OutputParametricSelector<
    AppState,
    UnitTypesProps,
    UnitType[K],
    (res: UnitType) => UnitType[K]
> =>
    createDeepEqualSelector(selectUnitType, unitType => {
        return get(unitType, fieldName);
    });

export {
    selectUnitTypes,
    selectUnitTypeOptions,
    selectUnitTypeId,
    selectUnitTypesKeyedById,
    selectUnitType,
    makeSelectUnitTypeFieldValue
};
